import React from 'react'
import {Link} from "gatsby";

import {locales, getCurrentLocale} from "../../utils/getCurrentLocale";

import langMenuStyles from './langMenu.module.scss'


const LangMenu = (props) => {
    const currentLocale = getCurrentLocale(props.location.pathname);
    const currentPath = props.location.pathname.split('/').slice(-1)[0];

    return (
        <div className={langMenuStyles.menuContainer}>
            {Object.keys(locales).map((lang, idx) => <Link
                className={currentLocale == lang ? langMenuStyles.langLinkActive : langMenuStyles.langLink} key={idx}
                to={`/${lang}/${currentPath}`}>{lang}</Link>)}
        </div>
    )
};


export default LangMenu;